var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.7441 136.74V139.998H101.479V136.74L101.396 136.66L93.653 129.189V121.639H61.5701V129.189L53.827 136.66L53.7441 136.74Z",
    fill: "#BCBEC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.085 121.639H94.1318V128.982H61.085V121.639Z",
    fill: "#A7A9AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7441 136.412V139.996H101.479V136.412L101.396 136.324H53.827L53.7441 136.412Z",
    fill: "#A7A9AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7275 106.953H145.54V33.5156L42.7275 106.953Z",
    fill: "#C1E5F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 29.2347V118.132C12.4999 121.836 15.4954 124.867 19.1568 124.867H139.979C143.64 124.867 146.636 121.836 146.636 118.132V29.2347C146.636 25.5305 143.64 22.5 139.979 22.5H19.1572C15.4958 22.5 12.4999 25.5305 12.4999 29.2347Z",
    fill: "#F2F2F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 29.2104V107.217H146.636V29.2104C146.636 25.5196 143.64 22.5 139.979 22.5H19.1568C15.4954 22.5 12.4999 25.5196 12.4999 29.2104Z",
    fill: "#181C3F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5589 29.5605H139.575V100.158H19.5589V29.5605Z",
    fill: "#C3E6F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8528 35.0215H131.366V77.1663H66.8528V35.0215Z",
    fill: "#EEEEEE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8528 35.0215H131.366V40.8346H66.8528V35.0215Z",
    fill: "#E96666"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1617 47.3613H123.821V68.2195H74.1617V47.3613Z",
    fill: "#D2D6D6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5968 48.6641H99.1104V90.8089H34.5968V48.6641Z",
    fill: "#EEEEEE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5968 48.6641H99.1104V54.4771H34.5968V48.6641Z",
    fill: "#0099C9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.997 61.1211H84.2188V64.2352H47.997V61.1211Z",
    fill: "#D2D6D6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.997 69.5742H84.2188V72.6884H47.997V69.5742Z",
    fill: "#D2D6D6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.997 77.3164H84.2188V80.4306H47.997V77.3164Z",
    fill: "#D2D6D6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8898 64.2352C87.1165 64.2352 86.4896 63.5381 86.4896 62.6782C86.4896 61.8182 87.1165 61.1211 87.8898 61.1211C88.6631 61.1211 89.29 61.8182 89.29 62.6782C89.29 63.5381 88.6631 64.2352 87.8898 64.2352Z",
    fill: "#FF9966"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8898 72.6884C87.1165 72.6884 86.4896 71.9912 86.4896 71.1313C86.4896 70.2713 87.1165 69.5742 87.8898 69.5742C88.6631 69.5742 89.29 70.2713 89.29 71.1313C89.29 71.9912 88.6631 72.6884 87.8898 72.6884Z",
    fill: "#E52B50"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8898 80.4306C87.1165 80.4306 86.4896 79.7334 86.4896 78.8735C86.4896 78.0135 87.1165 77.3164 87.8898 77.3164C88.6631 77.3164 89.29 78.0135 89.29 78.8735C89.29 79.7334 88.6631 80.4306 87.8898 80.4306Z",
    fill: "#4EC9DF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d99d106ebf5ca2543d99e1259b764fe2.svg";
export { ForwardRef as ReactComponent };